// extracted by mini-css-extract-plugin
export var bodySections = "_cv-8";
export var gray = "_cv-7";
export var green = "_cv-4";
export var iconContainer = "_cv-9";
export var iconWidgetContainer = "_cv-1";
export var phoneIcon = "_cv-2";
export var red = "_cv-5";
export var statusDot = "_cv-3";
export var widgetContainer = "_cv-0";
export var yellow = "_cv-6";